const LOGO = "/fabg-logo.png";

export const Footer = ({
  tagline = "Canada’s First Full Arch Growth & Buying Network",
  disclaimer = "Pricing examples shown in USD and are from the existing U.S. network. Actual pricing varies by vendor and volume. FABG Canada vendor relationships are being established.",
}) => {
  return (
    <footer className="border-t border-border bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-3">
            <img src={LOGO} alt="FABG" className="h-8 w-auto" />
            <span className="text-sm text-muted-foreground">{tagline}</span>
          </div>
          {disclaimer ? (
            <p className="text-xs text-muted-foreground max-w-md">{disclaimer}</p>
          ) : null}
        </div>
        <div className="mt-8 border-t border-border pt-6 text-xs text-muted-foreground">
          &copy; {new Date().getFullYear()} FABG (Full Arch Buying Group). All rights reserved.
        </div>
      </div>
    </footer>
  );
};
